import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { BasicError, err, isError } from "@nju/result";
import { IReservationMode, IReserveAppointmentSlotResult } from "./types";
import { serverResponse, verificationErrorResponse } from "./validators";

interface IParams {
  appointmentTimeSlot: {
    endDate: string;
    startDate: string;
  };
  contactNumber: string;
  note: string | undefined;
  orchestratorId: string;
  mode: IReservationMode;
}

export async function reserveAppointmentSlot(
  params: IParams,
): Promise<IReserveAppointmentSlotResult> {
  const { mode, orchestratorId, ...data } = params;

  const actions = {
    RESERVE: "APPOINTMENT_SLOT_RESERVE",
    CHANGE: "APPOINTMENT_SLOT_CHANGE",
    CHANGE_FULFILLMENT: "APPOINTMENT_SLOT_CHANGE_FULFILLMENT",
  } as Record<IReservationMode, string>;

  const actionType = actions[mode];

  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/orchestrators/${orchestratorId}/actions/${actionType}`,
    {
      method: "post",
      validator: serverResponse,
      json: data,
    },
  );

  if (isError(result)) {
    const errorInfo = verificationErrorResponse.safeParse(
      result.err.extra?.json,
    );

    if (errorInfo.success) {
      if (errorInfo.data.code === "50138") {
        return err(
          new BasicError({
            message: "invalid appointment code",
            code: "INVALID_APPOINTMENT_CODE",
          }),
        );
      }

      if (errorInfo.data.code === "50137") {
        return err(
          new BasicError({
            message: "appointment slot already taken",
            code: "APPOINTMENT_SLOT_TAKEN",
          }),
        );
      }
    }

    Bugsnag.notify(result.err);
    return result;
  }

  return result;
}
